import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import unsupportedContainsValidation, { containsControlCharacter } from './phraseValidator';

export class BaseValidator {
    protected VALIDATOR_RULES: ValidatorRule[] = [];

    constructor(rules: ValidatorRule[]) {
        this.VALIDATOR_RULES = rules;
    }

    protected EUCJPCharsRule(value: string, fieldName?: string): ValidatorResult {
        // Not allow except euc-jp character
        if (unsupportedContainsValidation(value)) {
            return {
                value: value,
                rule: 'EUCJPCharsRule',
                message: TranslationHelpers.getFormattedMessageProps(
                    'error.common.unsupported_char',
                    { field: fieldName ? TranslationHelpers.getFormattedMessage(fieldName) : ' ' },
                ),
            };
        }

        return null;
    }

    protected FullWidthSpaceRule(value: string, fieldName?: string): ValidatorResult {
        if (/\u3000/g.test(value)) {
            return {
                value: value,
                rule: 'FullWidthSpaceRule',
                message: TranslationHelpers.getFormattedMessageProps(
                    'error.common.include_full_width_space',
                    { field: fieldName ? TranslationHelpers.getFormattedMessage(fieldName) : ' ' },
                ),
            };
        }

        return null;
    }

    protected SpaceRule(value: string): ValidatorResult {
        if (/\s/g.test(value)) {
            return {
                value: value,
                rule: 'SpaceRule',
                message: TranslationHelpers.getMessageDescriptor('error.rakid.nospace'),
            };
        }
        return null;
    }

    protected PasswordSpaceRule(value: string): ValidatorResult {
        if (/\s/g.test(value)) {
            return {
                value: value,
                rule: 'PasswordSpaceRule',
                message: TranslationHelpers.getMessageDescriptor('error.password.no_space'),
            };
        }
        return null;
    }

    protected LatinCharactersRule(value: string): ValidatorResult {
        if (/[^\x20-\x7F]/g.test(value)) {
            return {
                value: value,
                rule: 'LatinCharactersRule',
                message: TranslationHelpers.getMessageDescriptor('error.encoding'),
            };
        }
        return null;
    }

    protected NoControlCharactersRule(value: string, fieldName?: string): ValidatorResult {
        if (containsControlCharacter(value)) {
            return {
                value: value,
                rule: 'NoControlCharactersRule',
                message: TranslationHelpers.getFormattedMessageProps(
                    'error.common.unsupported_char',
                    { field: fieldName ? TranslationHelpers.getFormattedMessage(fieldName) : ' ' },
                ),
            };
        }

        return null;
    }

    public validate(value: string, field: string) {
        let error: ValidatorResult = null;
        for (let i = 0; i < this.VALIDATOR_RULES.length; i++) {
            const rule = this.VALIDATOR_RULES[i];
            const validatorFunc = Reflect.get(this, rule);
            if (validatorFunc) {
                error = validatorFunc(value, field) as ValidatorResult;

                if (error) break;
            }
        }
        return error;
    }
}
